/* eslint-disable */
import Vue from 'vue';
import router from '../../routes';

const jobgroup = {
    namespaced: true,
    state:{
        token:'',
        jobgroup:[],
    },
    getters:{
        getJobGroup(state) {
            return state.jobgroup;
        }
    },
    mutations: {
        getJobGroup(state,todoData) {
            state.jobgroup = todoData;
        },
    },
    actions:{
        getJobGroup({commit},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.get('jobgroup',{
                ...payload
            })
                .then(response => response.json())
                .then( jobgroupData => {
                    commit("getJobGroup",jobgroupData);
                })
                .catch( error => {
                    console.log(error);
                })
        }
    }
};

export default jobgroup;